import React from "react";
import OtpPage from "./OtpPage";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { DECCAN_URL, GENERAL_ERROR_MSG, PRAJAVANI_URL } from "../contant";
import { useLocation } from "react-router-dom";
import { getAppFlag } from "../utiles";

export default function EmailUpdateOtpPage() {
  const email = localStorage.getItem("changed_email") || "";
  const phoneNumber = localStorage.getItem("changed_phone") || "";
  const OtpPayloadData = JSON.parse(
    localStorage.getItem("create-otp-response")
  );
  const [userOTP, setUserOTP] = React.useState("");
  const [userOtpError, setUserOtpError] = React.useState(null);
  const [isDisableUserVerifyBtn, setIsDisableUserVerifyBtn] =
    React.useState(false);
  const callbackUrl = localStorage.getItem("callbackUrl") || "";
  const location = useLocation();
  const fieldWhichIsUpdated = location.pathname.includes("post_change_email")
    ? "email"
    : location.pathname.includes("post_change_phonenumber")
    ? "phone"
    : "";

  const verifyOTPHandler = async () => {
    const errorMsg = getAppFlag({ appUrl: DECCAN_URL })
      ? "Invalid OTP"
      : getAppFlag({ appUrl: PRAJAVANI_URL })
      ? "ಒಟಿಪಿ ಅಮಾನ್ಯ"
      : "";
    if (userOTP.length !== 6) {
      setUserOtpError(errorMsg);
      return;
    }
    try {
      setIsDisableUserVerifyBtn(true);
      const verifyOTPResponse = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_BASE_URL}/auth/verify-code`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("st-access-token")}`,
          rid: "thirdpartypasswordless",
          redirecturl: callbackUrl,
        },
        data: {
          preAuthSessionId: OtpPayloadData.preAuthSessionId,
          deviceId: OtpPayloadData.deviceId,
          userInputCode: userOTP,
        },
      });
      if (verifyOTPResponse.status === 200) {
        toast.success("OTP successfully verified");
        window.location.assign(
          `${callbackUrl}?access_token=${verifyOTPResponse.headers["st-access-token"]}&refresh_token=${verifyOTPResponse.headers["st-refresh-token"]}`
        );
      }
    } catch (error) {
      console.log("errorMessage", error.response);
      if (error?.response?.status === 409) {
        toast.error(error?.response?.data);
      } else if (
        error?.response?.status === 400 &&
        error?.response?.data?.status === "INCORRECT_USER_INPUT_CODE_ERROR"
      ) {
        setUserOtpError(errorMsg);
      } else {
        toast.error(GENERAL_ERROR_MSG);
      }
    } finally {
      setIsDisableUserVerifyBtn(false);
    }
  };

  const resendOTPHandler = async () => {
    let apiRouteForUpdateEmailOrPhone, reqPayload;
    if (fieldWhichIsUpdated === "email") {
      apiRouteForUpdateEmailOrPhone = "change-email";
      reqPayload = {
        email,
      };
    } else {
      apiRouteForUpdateEmailOrPhone = "change-phone-number";
      reqPayload = {
        phoneNumber: `+91${phoneNumber}`,
      };
    }
    try {
      const resendOTPResponse = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_BASE_URL}/auth/${apiRouteForUpdateEmailOrPhone}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("st-access-token")}`,
          rid: "thirdpartypasswordless",
          redirecturl: callbackUrl,
        },
        data: reqPayload,
      });
      if (resendOTPResponse.status === 200) {
        localStorage.setItem(
          "create-otp-response",
          JSON.stringify(resendOTPResponse.data)
        );
        toast.success("OTP successfully sent");
      }
    } catch (error) {
      console.log("errorMessage", error.response);
      if (error?.response?.status === 409) {
        toast.error(error?.response?.data);
      } else {
        toast.error(GENERAL_ERROR_MSG);
      }
    }
  };

  return (
    <OtpPage
      verifyOTPHandler={verifyOTPHandler}
      updatedFieldData={fieldWhichIsUpdated === "email" ? email : phoneNumber}
      fieldWhichIsUpdated={fieldWhichIsUpdated}
      resendOTPHandler={resendOTPHandler}
      setUserOTP={setUserOTP}
      userOTP={userOTP}
      userOtpError={userOtpError}
      setIsDisableUserVerifyBtn={setIsDisableUserVerifyBtn}
      isDisableUserVerifyBtn={isDisableUserVerifyBtn}
      setUserOtpError={setUserOtpError}
    />
  );
}
